import { jwtDecode } from 'jwt-decode';
const CLOCK_TOLERANCE_SEC = 600;
const REFRESH_INTERVAL_MS = 10000;
/**
 * Starts a 10s polling loop. Every tick, reads the cached ID token, decodes its JWT exp,
 * and — if within the 600s tolerance window — forces a refresh and re-exchanges.
 *
 * Silent failure is INTENTIONAL (known bug #3, preserved bug-for-bug from src/auth.ts).
 */
export function startRefreshLoop(deps) {
    const handle = setInterval(async () => {
        try {
            const token = await deps.getIdentityToken();
            if (!token)
                return;
            const decoded = jwtDecode(token);
            const nowSec = Math.floor(Date.now() / 1000);
            if (decoded.exp && nowSec >= decoded.exp - CLOCK_TOLERANCE_SEC) {
                const refreshed = await deps.refreshIdentityToken();
                if (refreshed) {
                    await deps.onRefreshed(refreshed);
                }
            }
        }
        catch {
            // Silent failure preserved — see features/auth/engine/refreshLoop.ts intent note.
        }
    }, REFRESH_INTERVAL_MS);
    return {
        stop() {
            clearInterval(handle);
        },
    };
}
